const excludedFields = [
  "employmentStatus",
  "relativeLGS",
  "relativeClient",
  "positionApplied",
  "newStartDateTime",
  "newEndDateTime",
  "area",
  "coordinator",
  "onBoardDate",
  "onBoardStartTime",
  "onBoardEndTime",
  "hireStartDate",
  "hireEndDate",
  "applicant",
  "referenceNumber",
  "recruiter",
  "interviewCoordinator",
  "lastPayDate",
  "employeeImage",
  "image1",
  "image2",
  "contact_name",
  "contact_houseNumber",
  "contact_street",
  "contact_subdivision",
  "contact_barangay",
  "contact_city",
  "contact_province",
  "contact_zipCode",
  "contact_telephone",
  "contact_relationship",
  "onBoardRemarks",
  "remarks",
  "termsAgreed",
  "signature",
  "orientationDate",
  "deploymentType",
  "additionalEmail",
  "hireDate",
  "startDate",
  "email",
  "deployedAt",
  "endDate",
  "medicalValidDate",
  "mayorPermitValidDate",
  "healthPermitValidDate",
  "nbiValidDate",
  "policeClearanceValidDate",
  "cv",
  "exit_interview",
];

export default excludedFields;
